module.exports = __webpack_public_path__ + "mobile/img/formMarket-img1.3f262a15.png";